<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-inner-wrapper" ngDraggable [handle]="ModalHandle">
  <div class="modal-header">
    <h4 class="modal-title">
      <span *ngIf="hotelBooking?.id">
        {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.EDIT' | translate }}
        <span> #{{ hotelBooking.id }}</span>
      </span>
      <span *ngIf="!hotelBooking?.id">{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ADD' | translate }}</span>
    </h4>

    <div
      class="btn btn-drag"
      #ModalHandle
      container="body"
      [ngbTooltip]="'REQUESTS.REQUEST_FORM.MOVE_MODAL' | translate"
    >
      <i class="far fa-expand-arrows"></i>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
<!--      <span aria-hidden="true">&times;</span>-->
    </button>
  </div>

  <ng-scrollbar class="modal-body ps">
    <form id="hotel-bookings-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
      <div class="row">
        <div class="col-sm-12">
          <app-events-select
            [FormControl]="form.get('events')"
            [required]="true"
            [bookingMode]="true"
          ></app-events-select>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <app-hotel-select
              [parentFormGroup]="form"
              [geofenceFilter]="{
                lat:
                  form.get('events').value[0] && form.get('events').value[0].lat
                    ? form.get('events').value[0].lat
                    : null,
                long:
                  form.get('events').value[0] && form.get('events').value[0].long
                    ? form.get('events').value[0].long
                    : null
              }"
            >
            </app-hotel-select>
          </div>
        </div>

        <div class="col-sm-3">
          <app-user-select
            [label]="'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CONTRACTING_AGENT' | translate"
            [passFormControlName]="'contracting_agent_id'"
            [parentFormGroup]="form"
            [roleType]="UserRoleType.CONTRACTING_AGENT"
          ></app-user-select>
        </div>

        <div class="col-sm-3">
          <app-user-select
            [label]="'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.RESERVATION_AGENT' | translate"
            [passFormControlName]="'reservation_agent_id'"
            [parentFormGroup]="form"
            [roleType]="UserRoleType.RESERVATION_AGENT"
          ></app-user-select>
        </div>

        <div class="col-sm-3">
          <app-user-select
            [label]="'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.AMENDMENT_AGENT' | translate"
            [passFormControlName]="'amendment_agent_id'"
            [parentFormGroup]="form"
            [roleType]="UserRoleType.AMENDMENT_AGENT"
          ></app-user-select>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <app-supplier-select [parentFormGroup]="form"></app-supplier-select>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.COMPANY' | translate }}</label>
            <app-company-select [parentFormGroup]="form" [hideLabel]="true"></app-company-select>
          </div>
        </div>

        <div class="col-sm-2" *ngIf="!form.get('supplier_id').value">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CANCELLATION_TERMS' | translate }}</label>
            <app-type-select
              [parentFormGroup]="form"
              [groupType]="'booking_cancellation_terms'"
              [passFormControlName]="'cancellation_terms_id'"
            ></app-type-select>
          </div>
        </div>

        <div class="col-sm-1" *ngIf="!form.get('supplier_id').value">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.COMMISSION_PERCENT_SHORT' | translate }}</label>
            <input type="number" class="form-control" formControlName="commission_percent" />
          </div>
        </div>

        <div class="col-sm-1" *ngIf="!form.get('supplier_id').value">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEPOSIT_PERCENT_SHORT' | translate }}</label>
            <input type="number" class="form-control" formControlName="deposit_percent" />
          </div>
        </div>

        <div class="col-sm-1" *ngIf="!form.get('supplier_id').value">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CANCELLATION_CHARGE_PERCENT_SHORT' | translate }}</label>
            <input type="number" class="form-control" formControlName="cancellation_charge_percent" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.REF_NUMBER' | translate }}</label>
            <input type="text" class="form-control" formControlName="ref_number" />
          </div>
        </div>

        <div class="col-sm-1">
          <div class="form-group">
            <app-currency-select
              [parentFormGroup]="form"
              [passFormControlName]="'currency_id'"
              #currencySelectComponent
            >
            </app-currency-select>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.PROPERTY' | translate }}</label>
            <app-type-select
              [parentFormGroup]="form"
              [groupType]="'booking_properties'"
              [passFormControlName]="'property_id'"
            ></app-type-select>
          </div>
        </div>

        <div class="col-sm-2" *ngIf="form.get('supplier_id').value">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.BREAKFAST_PRICE_PER_NIGHT' | translate }}</label>
            <input type="text" class="form-control" formControlName="breakfast_price_per_night" />
          </div>
        </div>

        <div class="col-sm-1" *ngIf="form.get('supplier_id').value">
          <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.BREAKFAST_CURRENCY' | translate }}</label>
          <app-currency-select
            [parentFormGroup]="form"
            [passFormControlName]="'breakfast_price_per_night_currency_id'"
            [hideLabel]="true"
          >
          </app-currency-select>
        </div>

        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-4">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" formControlName="show_to_web" id="show-to-web" />
                <label class="custom-control-label" for="show-to-web">
                  {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.SHOW_TO_WEB' | translate }}
                </label>
              </div>
            </div>
            <div class="col-sm-4" *ngIf="form.get('supplier_id').value">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" formControlName="breakfast" id="breakfast" />
                <label class="custom-control-label" for="breakfast">
                  {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.BREAKFAST' | translate }}
                </label>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" formControlName="book" id="book" />
                <label class="custom-control-label" for="book">
                  {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.BOOK' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.NOTE' | translate }}</label>
            <textarea
              class="form-control note-textarea"
              formControlName="note"
              [rows]="1"
              [cols]="30"
              pInputTextarea
              autoResize="true"
            ></textarea>
          </div>
        </div>

        <div class="col-sm-12">
          <app-tags-select [parentFormGroup]="form" [model]="LaravelModelsEnum.HOTELBOOKING"></app-tags-select>
        </div>
      </div>

      <hr />

      <div class="d-flex justify-content-between">
        <div class="modal-section-title mb-2">
          {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ROOMS' | translate }}
        </div>

        <div>
          <small *ngIf="hotelBooking && hotelBooking?.id" class="pointer btn-link mr-4" (click)="toggleGroupedRooms()">
            <ng-container *ngIf="!grouped">
              {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.GROUP' | translate }}
            </ng-container>
            <ng-container *ngIf="grouped">
              {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.UNGROUP' | translate }}
            </ng-container>
          </small>

          <small
            *ngIf="this.showOnlyAllotmentId || this.showOnlyNights"
            (click)="toggleHiddenRooms()"
            class="pointer btn-link"
          >
            <ng-container *ngIf="showAllRooms">
              {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.FILTER_ROOMS' | translate }}
            </ng-container>
            <ng-container *ngIf="!showAllRooms">
              {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.SHOW_ALL_ROOMS' | translate }}
            </ng-container>
          </small>
        </div>
      </div>

      <div class="rooms-wrapper" formArrayName="rooms">
        <ng-container *ngFor="let room of form.get('rooms')?.controls; let i = index">
          <div class="single-room" [formGroupName]="i" *ngIf="room.get('hidden').value !== true || showAllRooms">
            <div class="room-header" *ngIf="hotelBooking?.id">
              <strong *ngIf="room.get('allotment_id').value">
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ALLOTMENT_ID' | translate }}:
              </strong>
              {{ room.get('allotment_id').value }}

              <strong *ngIf="room.get('created_at').value">
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CREATED_AT' | translate }}:
              </strong>
              {{ room.get('created_at').value | amDateFormat : env.momentDateTimeFormat }}
            </div>

            <button type="button" class="remove-room" (click)="removeRoom(i)">
              <i class="fal fa-times"></i>
            </button>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CHECK_IN' | translate }}</label>
                  <app-date-picker [FormControl]="room.get('check_in')" (select)="datesChange(i)"></app-date-picker>
                </div>
              </div>
              <div class="col-1">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.NIGHTS' | translate }}</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="nights_count"
                    (keyup)="nightsCountChange(i)"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CHECK_OUT' | translate }}</label>
                  <app-date-picker [FormControl]="room.get('check_out')" (select)="datesChange(i)"></app-date-picker>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ROOM_TYPE' | translate }}</label>
                  <app-type-select
                    [parentFormGroup]="room"
                    [groupType]="'rooms'"
                    [passFormControlName]="'type_id'"
                  ></app-type-select>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ROOM_COUNT' | translate }}</label>
                  <input type="number" class="form-control" formControlName="count" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.MEAL_PLAN' | translate }}</label>
                  <app-type-select
                    [parentFormGroup]="room"
                    [groupType]="'room_meal_plans'"
                    [passFormControlName]="'meal_plan_id'"
                  ></app-type-select>
                </div>
              </div>
              <div class="col-2">
                <app-min-nights-picker
                  [FormControlMinNightsFrom]="room.get('min_nights_from')"
                  [FormControlMinNightsTo]="room.get('min_nights_to')"
                  [defaultDate]="room.get('check_in').value"
                  [minDate]="room.get('check_in').value"
                  [maxDate]="room.get('check_out').value"
                ></app-min-nights-picker>
              </div>
            </div>
            <div class="row">
              <div class="col" [hidden]="room.get('different_price').value">
                <div class="form-group">
                  <label
                    >{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.NET_PRICE' | translate }}
                    <span *ngIf="currencySelectComponent.selectedCurrency">
                      (<app-currency-box [currency]="currencySelectComponent.selectedCurrency"></app-currency-box>)
                    </span>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="fake_net_price"
                    (keyup)="roomPriceChange(i)"
                  />
                  <div>
                    <app-currency-converter
                      [fromCurrency]="currencySelectComponent.selectedCurrency"
                      [value]="room.get('fake_net_price').value"
                    ></app-currency-converter>
                  </div>
                </div>
              </div>
              <div class="col" [hidden]="room.get('different_price').value">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.PRICE' | translate }}</label>
                  <input type="number" class="form-control" formControlName="fake_price" (keyup)="roomPriceChange(i)" />
                </div>
              </div>
              <div class="col" [hidden]="room.get('different_price').value">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.MARGIN' | translate }}</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="fake_margin"
                    (keyup)="roomMarginChange(i)"
                  />
                </div>
              </div>
              <div class="col" [hidden]="room.get('different_price').value">
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.WEB_PRICE' | translate }}</label>
                  <input type="number" class="form-control" formControlName="fake_web_price" />
                </div>
              </div>
              <div
                [ngClass]="{ col: !room.get('different_price').value, 'col-sm-2': room.get('different_price').value }"
              >
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.PEOPLE_COUNT' | translate }}</label>
                  <input type="number" class="form-control" formControlName="people" />
                </div>
              </div>

              <div
                *ngIf="!grouped || !hotelBooking?.id"
                [ngClass]="{ col: !room.get('different_price').value, 'col-sm-2': room.get('different_price').value }"
              >
                <div class="form-group">
                  <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ROOM_REF_NUMBER' | translate }}</label>
                  <input type="text" class="form-control" formControlName="ref_number" />
                </div>
              </div>

              <div class="col">
                <div class="custom-control custom-checkbox checkbox-margin">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    formControlName="show_to_web"
                    [attr.id]="'show-to-web-room-' + i"
                  />
                  <label class="custom-control-label" [attr.for]="'show-to-web-room-' + i">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.SHOW_TO_WEB' | translate }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <div class="d-flex gap-3">
                  <label class="custom-control custom-radio mb-0">
                    <input
                      type="radio"
                      class="custom-control-input"
                      formControlName="status"
                      value="offered"
                      (change)="roomStatusChange(i)"
                    />
                    <span class="custom-control-label">{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.STATUS.OFFERED' | translate }}</span>
                  </label>
                  <label class="custom-control custom-radio mb-0">
                    <input
                      type="radio"
                      class="custom-control-input"
                      formControlName="status"
                      value="booked"
                      (change)="roomStatusChange(i)"
                    />
                    <span class="custom-control-label">{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.STATUS.BOOKED' | translate }}</span>
                  </label>
                  <label class="custom-control custom-radio mb-0">
                    <input
                      type="radio"
                      class="custom-control-input"
                      formControlName="status"
                      value="cancelled"
                      (change)="roomStatusChange(i)"
                    />
                    <span class="custom-control-label">{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.STATUS.CANCELLED' | translate }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center flex-wrap">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  formControlName="different_price"
                  [attr.id]="'different_price_' + i"
                />
                <label class="custom-control-label" [attr.for]="'different_price_' + i">
                  {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DIFFERENT_PRICE' | translate }}
                </label>
              </div>
              <div *ngIf="room.get('id').value && room.get('nights').value && room.pristine && !grouped" class="ms-5">
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.NIGHTS_AVAILABLE' | translate }}

                <span
                  [ngClass]="{
                    'theme-color-danger fw-bold': room.get('availableNights').value < room.get('nights').value.length
                  }"
                >
                  {{ room.get('availableNights').value }}
                </span>
                / {{ room.get('nights').value.length }}
              </div>
            </div>

            <div class="nights-wrapper" [hidden]="!room.get('different_price').value">
              <div class="table table-bordered">
                <thead>
                  <tr>
                    <th>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_NUMBER' | translate }}</th>
                    <th>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_DATES' | translate }}</th>
                    <th>
                      {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_NET_PRICE' | translate }}
                      <span *ngIf="currencySelectComponent.selectedCurrency">
                        (<app-currency-box [currency]="currencySelectComponent.selectedCurrency"></app-currency-box>)
                      </span>

                      [{{
                        toEUR(meanBy(room.get('nights')?.value, 'net_price'), currencySelectComponent.selectedCurrency)
                      }}
                      {{ 'DEFAULT_CURRENCY' | translate }} AVG]
                    </th>
                    <th>
                      {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_PRICE' | translate }} ({{
                        'DEFAULT_CURRENCY' | translate
                      }}) [{{ meanBy(room.get('nights')?.value, 'price') | number : '1.2-2' }}
                      {{ 'DEFAULT_CURRENCY' | translate }} AVG]
                    </th>
                    <th>
                      {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_MARGIN' | translate }} ({{
                        'DEFAULT_CURRENCY' | translate
                      }}) [{{ meanBy(room.get('nights')?.value, 'margin') | number : '1.2-2' }}
                      {{ 'DEFAULT_CURRENCY' | translate }} AVG]
                    </th>
                    <th>
                      {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_WEB_PRICE' | translate }} ({{
                        'DEFAULT_CURRENCY' | translate
                      }}) [{{ meanBy(room.get('nights')?.value, 'web_price') | number : '1.2-2' }}
                      {{ 'DEFAULT_CURRENCY' | translate }} AVG]
                    </th>
                    <th>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_STATUS' | translate }}</th>
                    <th>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.TABLE_HEAD_GUESTS' | translate }}</th>
                    <th>
                      <i class="fal fa-plus"></i>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody formArrayName="nights">
                  <tr *ngFor="let night of room.get('nights')?.controls; index as j" [formGroupName]="j">
                    <td>{{ j + 1 }}</td>
                    <td>{{ night.get('date').value | date : env.pipeDateFormat }}</td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="net_price"
                        (keyup)="nightPriceChange(i, j)"
                      />

                      <app-currency-converter
                        [fromCurrency]="currencySelectComponent.selectedCurrency"
                        [value]="night.get('net_price').value"
                      ></app-currency-converter>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="price"
                        (keyup)="nightPriceChange(i, j)"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="margin"
                        (keyup)="nightMarginChange(i, j)"
                      />
                    </td>
                    <td>
                      <input type="number" class="form-control table-form-control-sm" formControlName="web_price" />
                    </td>
                    <td class="text-center">
                      <select class="form-control table-form-control-sm" formControlName="status">
                        <option value=""> </option>
                        <option value="offered">Offered</option>
                        <option value="booked">Booked</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <span *ngIf="night.get('guest_names').value?.length; else noGuests">
                        {{ night.get('guest_names').value.join(', ') }}
                      </span>
                      <ng-template #noGuests>—</ng-template>
                    </td>
                    <td class="text-center" style="width: 1%">
                      <span
                        style="padding-left: 30px"
                        [ngbTooltip]="'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.EXTRA_ROOM' | translate"
                        container="body"
                        class="custom-control custom-checkbox"
                        *ngIf="hotelBooking && hotelBooking.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          formControlName="extra"
                          [attr.id]="'extra' + i + '' + j"
                          [readOnly]="!night.get('isAvailable').value"
                        />
                        <label class="custom-control-label" [attr.for]="'extra' + i + '' + j"> </label>
                      </span>
                    </td>
                    <td>
                      <div *ngIf="!grouped">
                        <span
                          [ngbTooltip]="'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.NIGHT_MIN_NIGHT' | translate"
                          container="body"
                          class="nights-ico"
                          *ngIf="night.get('min_night').value"
                        >
                          <i class="fas fa-moon"></i>
                        </span>

                        <span
                          (click)="goToCancellation(night.get('hotel_booking_cancellation_id').value)"
                          [ngbTooltip]="
                            ('HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CANCELLATION_ID' | translate) +
                            night.get('hotel_booking_cancellation_id').value
                          "
                          container="body"
                          class="theme-color-danger pointer"
                          *ngIf="!night.get('isAvailable').value && night.get('hotel_booking_cancellation_id').value"
                        >
                          <i class="fas fa-do-not-enter"></i>
                        </span>

                        <span
                          (click)="goToSale(night.get('sale_id').value)"
                          [ngbTooltip]="
                            ('HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.SALE_FINAL_ITEM_ID' | translate) +
                            night.get('sale_final_item_id').value
                          "
                          container="body"
                          class="theme-color-success pointer"
                          *ngIf="
                            !night.get('isAvailable').value &&
                            night.get('sale_final_item_id').value &&
                            night.get('sale_id').value
                          "
                        >
                          <i class="fal fa-file-invoice-dollar"></i>
                        </span>

                        <span
                          container="body"
                          [ngbTooltip]="
                            ('HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.GUEST_NAMES' | translate) +
                            ': ' +
                            night.get('guest_names').value.join(', ')
                          "
                          *ngIf="night.get('guest_names').value"
                          class="theme-color-success"
                        >
                          <i class="fas fa-users"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="2">
                      {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.MASS_ACTIONS' | translate }}
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="table_foot_net_price"
                      />
                      <button
                        type="button"
                        class="btn btn-primary btn-ico"
                        (click)="fillNightsControls(i, 'net_price')"
                      >
                        <i class="fal fa-paper-plane"></i>
                      </button>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="table_foot_price"
                      />
                      <button type="button" class="btn btn-primary btn-ico" (click)="fillNightsControls(i, 'price')">
                        <i class="fal fa-paper-plane"></i>
                      </button>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="table_foot_margin"
                      />
                      <button type="button" class="btn btn-primary btn-ico" (click)="fillNightsControls(i, 'margin')">
                        <i class="fal fa-paper-plane"></i>
                      </button>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control table-form-control-sm"
                        formControlName="table_foot_web_price"
                      />
                      <button
                        type="button"
                        class="btn btn-primary btn-ico"
                        (click)="fillNightsControls(i, 'web_price')"
                      >
                        <i class="fal fa-paper-plane"></i>
                      </button>
                    </td>
                  </tr>
                </tfoot>
              </div>
            </div>
          </div>
        </ng-container>

        <div>
          <button
            type="button"
            class="btn btn-input btn-outline-primary mb-2"
            (click)="addRoom()"
            *ngIf="!showOnlyAllotmentId && !showOnlyNights"
          >
            {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.ADD_ROOM' | translate }}
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CANCELLATION_DEADLINE' | translate }}</label>
            <app-date-picker
              [FormControl]="form.get('cancellation_deadline')"
              [minDate]="cancellationDeadlineMinDate"
              [maxDate]="cancellationDeadlineMaxDate"
            ></app-date-picker>
          </div>
        </div>

        <div class="col-sm-1">
          <ng-template #popCancellationDeadline>
            <div class="popover-wrapper">
              <div class="form-group">
                <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_VALUE' | translate }}</label>
                <input type="number" class="form-control" value="7" #cancellationDeadlineValueInput />
              </div>

              <div class="form-group">
                <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD' | translate }}</label>
                <select class="form-control" #cancellationDeadlinePeriodInput>
                  <option value="days" selected>
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_DAYS' | translate }}
                  </option>
                  <option value="weeks">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_WEEKS' | translate }}
                  </option>
                  <option value="months">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_MONTHS' | translate }}
                  </option>
                </select>
              </div>

              <button
                type="button"
                class="btn btn-primary btn-xs"
                (click)="
                  fillDeadlineDate(
                    'cancellation_deadline',
                    cancellationDeadlineValueInput.value,
                    cancellationDeadlinePeriodInput.value,
                    cancellationDeadlinePopOver
                  )
                "
              >
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.POP_BTN_SET' | translate }}
              </button>
              <button type="button" class="btn btn-danger btn-xs" (click)="cancellationDeadlinePopOver.close()">
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.POP_BTN_CLOSE' | translate }}
              </button>
            </div>
          </ng-template>
          <button
            type="button"
            class="btn btn-outline-secondary btn-xs mt-4"
            [ngbPopover]="popCancellationDeadline"
            [autoClose]="false"
            triggers="manual"
            #cancellationDeadlinePopOver="ngbPopover"
            (click)="cancellationDeadlinePopOver.open()"
            popoverClass="quick_set_booking_deadline_popover"
            container="body"
          >
            {{ 'QUICK_SET' | translate }}
          </button>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.PAYMENT_DEADLINE' | translate }}</label>
            <app-date-picker [FormControl]="form.get('payment_deadline')"></app-date-picker>
          </div>
        </div>

        <div class="col-sm-1">
          <ng-template #popPaymentDeadline>
            <div class="popover-wrapper">
              <div class="form-group">
                <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_VALUE' | translate }}</label>
                <input type="number" class="form-control" value="7" #PaymentDeadlineValueInput />
              </div>

              <div class="form-group">
                <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD' | translate }}</label>
                <select class="form-control" #PaymentDeadlinePeriodInput>
                  <option value="days" selected>
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_DAYS' | translate }}
                  </option>
                  <option value="weeks">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_WEEKS' | translate }}
                  </option>
                  <option value="months">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_MONTHS' | translate }}
                  </option>
                </select>
              </div>

              <button
                type="button"
                class="btn btn-primary btn-xs"
                (click)="
                  fillDeadlineDate(
                    'payment_deadline',
                    PaymentDeadlineValueInput.value,
                    PaymentDeadlinePeriodInput.value,
                    PaymentDeadlinePopOver
                  )
                "
              >
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.POP_BTN_SET' | translate }}
              </button>
              <button type="button" class="btn btn-danger btn-xs" (click)="PaymentDeadlinePopOver.close()">
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.POP_BTN_CLOSE' | translate }}
              </button>
            </div>
          </ng-template>
          <button
            type="button"
            class="btn btn-outline-secondary btn-xs mt-4"
            [ngbPopover]="popPaymentDeadline"
            [autoClose]="false"
            triggers="manual"
            #PaymentDeadlinePopOver="ngbPopover"
            (click)="PaymentDeadlinePopOver.open()"
            popoverClass="quick_set_booking_deadline_popover"
            container="body"
          >
            {{ 'QUICK_SET' | translate }}
          </button>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.OFFER_DEADLINE' | translate }}</label>
            <app-date-picker [FormControl]="form.get('offer_deadline')" [required]="false"></app-date-picker>
          </div>
        </div>

        <div class="col-sm-1">
          <ng-template #popOfferDeadline>
            <div class="popover-wrapper">
              <div class="form-group">
                <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_VALUE' | translate }}</label>
                <input type="number" class="form-control" value="7" #OfferDeadlineValueInput />
              </div>

              <div class="form-group">
                <label>{{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD' | translate }}</label>
                <select class="form-control" #OfferDeadlinePeriodInput>
                  <option value="days" selected>
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_DAYS' | translate }}
                  </option>
                  <option value="weeks">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_WEEKS' | translate }}
                  </option>
                  <option value="months">
                    {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DEADLINE_POPOVER_PERIOD_MONTHS' | translate }}
                  </option>
                </select>
              </div>

              <button
                type="button"
                class="btn btn-primary btn-xs"
                (click)="
                  fillDeadlineDate(
                    'offer_deadline',
                    OfferDeadlineValueInput.value,
                    OfferDeadlinePeriodInput.value,
                    OfferDeadlinePopOver
                  )
                "
              >
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.POP_BTN_SET' | translate }}
              </button>
              <button type="button" class="btn btn-danger btn-xs" (click)="OfferDeadlinePopOver.close()">
                {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.POP_BTN_CLOSE' | translate }}
              </button>
            </div>
          </ng-template>
          <button
            type="button"
            class="btn btn-outline-secondary btn-xs mt-4"
            [ngbPopover]="popOfferDeadline"
            [autoClose]="false"
            triggers="manual"
            #OfferDeadlinePopOver="ngbPopover"
            (click)="OfferDeadlinePopOver.open()"
            popoverClass="quick_set_offer_deadline_popover"
            container="body"
          >
            {{ 'QUICK_SET' | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="form?.get('created_at')?.value && hotelBooking?.id">
        <strong> {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CREATED_AT' | translate }}: </strong>
        {{ form?.get('created_at')?.value?.getDateTime() }}
      </div>
    </form>
  </ng-scrollbar>

  <div class="modal-footer d-flex justify-content-between">
    <div>
      <app-payment-button
        *ngIf="hotelBooking?.id"
        [iconBtn]="false"
        [paymentable_id]="hotelBooking.id"
        [paymentable_type]="LaravelModelsEnum.BOOKING"
      >
      </app-payment-button>

      <button
        *ngIf="hotelBooking?.id"
        type="button"
        class="btn btn-outline-dark btn-xs"
        [swal]="{
          titleText: 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CONFIRM.DUPLICATE_TITLE' | translate,
          text: 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.CONFIRM.DUPLICATE_TEXT' | translate
        }"
        (confirm)="duplicate()"
      >
        {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.DUPLICATE' | translate }}
      </button>
    </div>

    <div class="d-flex">
      <select
        *ngIf="final && final.items && final.items.length > 1"
        class="form-control me-2"
        #selElement
        (change)="goToBooking(selElement.selectedIndex)"
      >
        <ng-container *ngFor="let itm of this.final.items; let i = index">
          <option [value]="i" [selected]="currentBookingIndex === i">{{ i + 1 }}</option>
        </ng-container>
      </select>

      <button
        *ngIf="final && final.items && final.items.length > 1"
        [disabled]="!final.items[currentBookingIndex - 1]"
        type="button"
        class="btn"
        (click)="goToBooking(currentBookingIndex - 1)"
      >
        <i class="far fa-arrow-left"></i>
      </button>

      <button
        *ngIf="final && final.items && final.items.length > 1"
        [disabled]="!final.items[currentBookingIndex + 1]"
        type="button"
        class="btn me-2"
        (click)="goToBooking(currentBookingIndex + 1)"
      >
        <i class="far fa-arrow-right"></i>
      </button>

      <!--      <div (click)="test(form)">testt</div>-->
      <button type="submit" class="btn btn-outline-dark btn-xs" form="hotel-bookings-form" [disabled]="form.invalid">
        {{ 'HOTEL_BOOKINGS.HOTEL_BOOKINGS_FORM.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
